import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		width: "100%",
		height: "100%",
		minHeight: 0,
		padding: theme.spacing(3),
		background: theme.palette.pageBackground || "#f8fafc",
		boxSizing: "border-box",
		overflowY: "auto",
		overflowX: "hidden",
		display: "flex",
		[theme.breakpoints.up("lg")]: {
			padding: theme.spacing(4),
		},
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(2.5),
		},
		[theme.breakpoints.down("xs")]: {
			padding: theme.spacing(2),
		},
	},

	contentWrapper: {
		flex: 1,
		minHeight: "100%",
		width: "100%",
		maxWidth: 1440,
		margin: "0 auto",
		overflow: "visible",
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(3),
		minWidth: 0,
		[theme.breakpoints.down("xs")]: {
			gap: theme.spacing(2),
		},
	},
	fullWidth: {
		maxWidth: "none",
	},
}));

const MainContainer = ({ children, className = "", fullWidth = false }) => {
	const classes = useStyles();

	return (
		<div className={classes.mainContainer}>
			<div className={`${classes.contentWrapper} ${fullWidth ? classes.fullWidth : ""} ${className}`}>
				{children}
			</div>
		</div>
	);
};

export default MainContainer;
